// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__xnjIY","footer":"ReportModalFilter_footer__1IMXS"};